import { withInstall } from '@lit-element/utils'
import CollapseTransition from './src/collapse-transition.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCollapseTransition: SFCWithInstall<typeof CollapseTransition> =
  withInstall(CollapseTransition)

export default LtCollapseTransition
